import { Navigate, useParams } from "react-router";
import { LoadingView } from "@/components/LoadingView/LoadingView";
import { useEvaluation } from "@/hooks/useEvaluation/useEvaluation";

export function SectionEvaluationRedirect() {
  const { callId } = useParams();

  const { loading, evaluation } = useEvaluation(callId);

  if (loading) {
    return <LoadingView />;
  }

  if (!evaluation) {
    return <Navigate to="empty" />;
  }

  return <Navigate to="result" />;
}
